import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17.0942 7.87695c-.5361 0-.9712-.43509-.9712-.97119s.4351-.97119.9712-.97119.9712.43509.9712.97119-.4351.97119-.9712.97119z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2362 22L2 12.7638l9.8947-9.89474C12.4504 2.31337 13.2075 2 13.9925 2h5.0407C20.6714 2 22 3.32856 22 4.96681v5.04069c0 .7839-.3134 1.5391-.8653 2.094l-.0038.0038L11.2362 22zm-6.41882-9.2362l6.41882 6.4188 8.486-8.486c.1813-.1823.2856-.4327.2856-.6891V4.96681c0-.53799-.4366-.97462-.9746-.97462h-5.0407c-.2564 0-.5068.10331-.6891.28556L4.81738 12.7638z",
    fill: "currentColor"
  }));
});